import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { livePrimaryContentItemContent$key } from "~/queries/__generated__/livePrimaryContentItemContent.graphql";

import {
  ActionBar,
  Container,
  CoverImage,
  Headline,
  Section,
  StyledEntityLink,
  Summary,
} from "./styles";

export type Props = {
  reference: livePrimaryContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemLivePrimary = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment livePrimaryContentItemContent on Content {
          ...entityLink
          entityId
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <Section>{provider.sections()}</Section>
        <Headline>
          <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
            {provider.headline({ preferSocialHeadline: true })}
          </StyledEntityLink>
        </Headline>
        <Summary>
          <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
            {provider.summary({
              isTextOverflowEllipsis: true,
            })}
          </StyledEntityLink>
        </Summary>
        <ActionBar>
          {provider.actionBar({
            commentVariant: "reverse",
            displayDateVariant: "publishedDate",
            isBookmarkVisible: false,
          })}
        </ActionBar>
        <CoverImage>
          <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
            {provider.coverImage({
              responsiveVariants: {
                desktopUp: "size540x360",
                mobileUp: "size540x360",
                tabletUp: "size540x360",
              },
              withCaption: false,
            })}
          </StyledEntityLink>
        </CoverImage>
      </Container>
    );
  },
);

ContentItemLivePrimary.displayName = "ContentItemLivePrimary";
